import { AssetClassType } from "src/app/core/linked-tables";

export function addBuildingAsAssetClass(arr: AssetClassType[]): AssetClassType[] {
    const buildingAsset = new AssetClassType();
    buildingAsset.id = 0;
    buildingAsset.name = 'Building';
    arr.push(buildingAsset);
    return arr;
}